import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";

export type Request = {
  userId: number;
  currPass: string;
  newPass: string;
};

const useChangePassword = () => {
  const clients = useClientContext();
  const changePassword = useMutation({
    mutationFn: (req: Request) => clients.management.changePassword(req),
  });

  return { changePass: changePassword };
};

export default useChangePassword;
